angular.module('elidb').filter('age', function(ELIService){
	return function(age){
		if(!age) return age;
		var trace = angular.trace;

		return age.replace(/^.*?\((.*?)\)$/gim,"$1");
	};
});